import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocaleContext } from '../../context/LocaleContext';
import EN from '../../../EN.json';
import FR from '../../../FR.json';
import { Heading, FormContainer } from './css';
import AccessToggle from './components/accessToggle';

const AccessControl = ({ formsControl, setFormsControl }) => {
  const locale = useLocaleContext()
  const {
    DEFECT_MANAGEMENT: { labelAvailableForm, accessControlFormsList }
  } = locale === 'en-US' ? EN : FR;

  useEffect(() => {
    if (Object.keys(formsControl).length === 0) {
      const initialState = accessControlFormsList.reduce((acc, current) => {
        return { ...acc, [current.key]: false };
      }, {});

      setFormsControl(initialState);
    }
  }, []);

  return (
    <>
      <Heading>{labelAvailableForm}</Heading>
      <FormContainer>
        {accessControlFormsList.map(item => (
          <AccessToggle
            data={item}
            formsControl={formsControl}
            setFormsControl={setFormsControl}
          />
        ))}
      </FormContainer>
    </>
  );
};

AccessControl.propTypes = {
  formsControl: PropTypes.shape(PropTypes.object).isRequired,
  setFormsControl: PropTypes.func.isRequired
};

export default AccessControl;
